import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Placeholder from "@/pages/Placeholder";
import Manifesto from "@/pages/Manifesto";
import Architecture from "@/pages/Architecture";
import ArchitectureBlueprint from "@/pages/ArchitectureBlueprint";
import ArchitectureWorkflow from "@/pages/ArchitectureWorkflow";
import ArchitectureAgents from "@/pages/ArchitectureAgents";
import Collections from "@/pages/Collections";
import TalesFeed from "@/pages/TalesFeed";
import RepositoryIndex from "@/pages/RepositoryIndex";
import RepositoryDocument from "@/pages/RepositoryDocument";
import RepositoryIdea from "@/pages/RepositoryIdea";
import LetsTalk from "@/pages/LetsTalk";
import Admin from "@/pages/Admin";
import AiReadable from "@/pages/AiReadable";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/architecture/blueprint" element={<ArchitectureBlueprint />} />
          <Route path="/architecture/workflow" element={<ArchitectureWorkflow />} />
          <Route path="/architecture/engine" element={<ArchitectureWorkflow />} />
          <Route path="/architecture/agents" element={<ArchitectureAgents />} />
          <Route path="/architecture/world" element={<ArchitectureAgents />} />
          <Route path="/repository" element={<RepositoryIndex />} />
          <Route path="/repository/idea/:id" element={<RepositoryIdea />} />
          <Route path="/repository/:id" element={<RepositoryDocument />} />
          <Route path="/lets-talk" element={<LetsTalk />} />
          <Route path="/art-dept" element={<Collections />} />
          <Route path="/art-dept/tales" element={<TalesFeed />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/ai" element={<AiReadable />} />
          <Route path="*" element={<Placeholder title="NOT FOUND" />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(42, 52, 47, 0.92)",
            color: "#E2E8D3",
            border: "1px solid rgba(226, 232, 211, 0.18)",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "12px",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
